(ns common.schema.calculated-field)

;; you should only use this function to calculate the value - this way it's easier to find all the places where
;; function is evaluated

(defn calculate [{:keys [calc-fn
                         get-field-schema
                         entity-data entity-lookup reverse-lookup
                         display-string tr bigdec->float] :as args}]
  #?(:cljs
     (try
       (calc-fn args)
       (catch js/Object o
         (println "Calculation failed " o)))
     :clj
     (try
       (calc-fn args)
       (catch Throwable th
         (println "Calculation failed " th)
         (.printStackTrace th)))))
